import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { setQuantityProducts } from "./products";
import { Creators as SearchProductsActions } from "../ducks/search";
import { getCartFromStorage } from "./cart";
import removeAccents from "remove-accents";

export function* getProductsBySearchTerm(action) {
  try {
    let { offset, limit, resetCategory } = yield select(state => state.search);
    const {
      searchTerm,
      filters,
      searchOrdering,
      category,
      subcategory,
      segment,
      offset: offsetSearch,
      limit: limitSearch
    } = action.payload;

    if (offsetSearch !== undefined && limitSearch !== undefined) {
      offset = offsetSearch;
      limit = limitSearch;
    }

    const store = yield select(state => state.storeByUser.data);

    // Agrupa filtros por tipo
    const filtersByType = {};
    if (filters && filters.length > 0) {
      filters.forEach(filter => {
        const type = filter.type || filter.key;
        if (!filtersByType[type]) {
          filtersByType[type] = [];
        }
        filtersByType[type].push(filter.value);
      });
    }

    // Monta o body com todos os dados
    const body = {
      termo: removeAccents(searchTerm),
      store: store ? store.uuid : null,
      filters: filtersByType,
      categoria: (category && !resetCategory) ? category : null,
      subcategoria: (subcategory && !resetCategory) ? [subcategory] : [],
      segmento: (segment && !resetCategory) ? segment : null,
      ordering: searchOrdering || 'relevancia'
    };

    // URL simplificada - apenas offset e limit
    const url = `products/search?_offset=${offset}&_limit=${limit}`;

    const { data: { foundProducts, totalizadorGeral } } = yield call(
      api.post,
      url,
      body
    );

    const products = yield setQuantityProducts(foundProducts);
    yield put(SearchProductsActions.searchProductsSuccess(products, totalizadorGeral));
  } catch (err) {
    yield put(
      SearchProductsActions.searchProductsFailure('Erro ao buscar produtos')
    );
  }
}

export function* setQuantityProductsFound() {
  const { productsFound } = yield select(state => state.search);

  if (productsFound && productsFound.length > 0) {
    const storageProducts = yield getCartFromStorage();

    const products = productsFound.map(productsFound => {
      const storageProduct = storageProducts.itens.find(
        storageProduct => storageProduct.id === productsFound.id
      );

      return {
        ...productsFound,
        quantidade: !storageProduct
          ? productsFound.quantidade
          : productsFound.quantidade !== storageProduct.quantidade
            ? storageProduct.quantidade
            : productsFound.quantidade
      };
    });

    yield put(SearchProductsActions.setQuantityProductsFoundSuccess(products));
  }
}
